import * as React from 'react';
import GarmentSizeTable from './garment-size-table';
import MdcSelect from 'PyzShopUi/scripts/shop-ui/components/select/MdcSelect';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';

const garmentSizeContainer = props => {
    const { garmentSizeCollection,
        garmentSizeData,
        garmentSizeImageUrl,
        garmentSizeTypes,
        tableSelectData,
    } = props;

    const { translate } = useTranslationHook();

    const [selectedTable, changeTableSelection] = React.useState(
        garmentSizeCollection[0] ? garmentSizeCollection[0].uniqueIdentifier : ''
    );

    return (
        <React.Fragment>
            <div className="grid-x">
                <div className="cell">
                    <p>
                        {translate('To ensure that your clothing fits perfectly and provides you with the required level of protection, you should check your measurements. It\'s best to measure yourself in your underwear or protective undergarments.', { ns: 'garment-size' })}
                    </p>
                </div>
                <div className="cell text-center small-12 medium-4">
                    <img src={garmentSizeImageUrl} alt={translate('Clothes/Shoe size', { ns: 'garment-size' })} />
                </div>
                <div className="cell small-12 medium-8">
                    <dl>
                        {Object
                            .entries(garmentSizeTypes)
                            .filter(type => garmentSizeData.allowedTypes.includes(type[0]))
                            .map(type => {
                                return <React.Fragment key={type[0]}>
                                    <dt>{type[0]}</dt>
                                    <dd><strong>{translate(type[1][0], { ns: 'garment-size'})}</strong> {translate(type[1][1], { ns: 'garment-size'})}
                                    </dd>
                                </React.Fragment>;
                            })
                        }
                    </dl>
                </div>
                {tableSelectData &&
                <div className="cell">
                    <MdcSelect {...tableSelectData} selectedValue={selectedTable} onChange={changeTableSelection} fullWidth={true} />
                </div>
                }
                <div className="cell">
                    {garmentSizeCollection
                        .filter(table => selectedTable === table.uniqueIdentifier)
                        .map((table, tableLoopIndex) => {
                            const tableData = { table, tableLoopIndex, garmentSizeTypes };

                            return (
                                <GarmentSizeTable key={tableLoopIndex} {...tableData} />
                            );
                        })
                    }
                </div>
            </div>
        </React.Fragment>
    );
};

export default garmentSizeContainer;
